import dayjs from "dayjs";
import { toVehicleReference } from "./to-vehicle-reference";
import { toVehicleUsageType } from "./to-vehicle-usage-type";
import type { ActiveVehicleUsageListItem } from "../../types/vehicle-usage.types";
import type { VehicleUsageDto } from "@/lib/api";
import { toPeriod } from "@/utils/mappers/to-period";
import { withImageVersion } from "@/utils/with-image-version/with-image-version";

export function toActiveVehicleUsageListItem(
	dto: VehicleUsageDto
): ActiveVehicleUsageListItem {
	const { vehicleUsage, vehicle, user, booking } = dto;
	const plannedEnd = booking?.plannedPeriod.end;
	const isOverdue = !!plannedEnd && dayjs(plannedEnd).isBefore(dayjs());
	const overdueByMinutes =
		isOverdue && plannedEnd ? dayjs().diff(plannedEnd, "minute") : undefined;

	return {
		id: vehicleUsage?.id,
		bookingId: booking?.id ?? vehicleUsage?.bookingId,
		vehicleId: vehicle?.id,
		usageType: toVehicleUsageType(booking),
		plannedPeriod: toPeriod(booking?.plannedPeriod),
		vehicle: vehicle ? toVehicleReference(vehicle) : undefined,
		driver: user
			? {
					remoteId: user.remoteId,
					userName: user.userName,
					displayName: user.displayName,
					imageUrl: withImageVersion(user.imageUrl),
				}
			: undefined,
		client: booking?.client
			? { id: booking.client.id, name: booking.client.name }
			: undefined,
		status: vehicleUsage?.status,
		statusMessage: vehicleUsage?.statusMessage,
		period: toPeriod(vehicleUsage?.period),
		mileageStartValue: dto.mileageStartValue,
		mileageEndValue: dto.mileageEndValue,
		mileageDelta: dto.mileageDelta,
		isOverdue,
		overdueByMinutes,
	};
}
